module.exports = __webpack_public_path__ + "static/img/3.424875b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/3.png
// module id = Bt0n
// module chunks = 0